import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Icon from '../../../../core/Icon';
import connect from '../../../../core/EcrionProvider/connect';

var styles = function styles(theme) {
  return createStyles({
    root: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      backgroundColor: '#FFF',
      'a:hover &, a:focus &, &:hover, &:focus': {
        backgroundColor: theme.common.Page.NavBar.style.hoverBackground
      },
      'a:active &, &:active': {
        backgroundColor: theme.common.Page.NavBar.style.activeBackground
      }
    },
    environmentText: {
      height: '100%',
      lineHeight: "".concat(theme.common.Page.NavBar.style.height, "px"),
      whiteSpace: 'pre',
      color: theme.common.Page.NavBar.style.color,
      fontWeight: 'bold'
    },
    environmentAvatarWrapper: {
      marginRight: theme.spacing(0.5),
      color: theme.common.Page.NavBar.style.color
    },
    environmentAvatar: {
      width: theme.spacing(3),
      height: theme.spacing(3)
    },
    environmentLogoWrapper: {
      height: '20px',
      marginTop: '3px',
      marginRight: '3px'
    },
    specifiedEnvironmentLogo: {},
    defaultEnvironmentLogo: {}
  });
};
/**
 * @extends {React.Component<Props>}
 */


var NavBarEnvironment =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavBarEnvironment, _React$Component);

  function NavBarEnvironment() {
    _classCallCheck(this, NavBarEnvironment);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavBarEnvironment).apply(this, arguments));
  }

  _createClass(NavBarEnvironment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme,
          userInfo = _this$props.userInfo,
          dispatch = _this$props.dispatch,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, ["classes", "theme", "userInfo", "dispatch", "style"]);

      var styleProp = {};
      if (style) styleProp = _objectSpread({}, style);
      if (!styleProp.display) styleProp.display = 'inline-block';
      return React.createElement(React.Fragment, null, React.createElement("div", Object.assign({
        style: styleProp
      }, rest, {
        className: classes.root
      }), React.createElement(Grid, {
        container: true,
        justify: "flex-start",
        alignItems: "center",
        wrap: "nowrap"
      }, React.createElement(Grid, {
        item: true,
        className: classes.environmentAvatarWrapper
      }, userInfo.environmentLogo ? React.createElement(Avatar, {
        src: userInfo.environmentLogo,
        className: classes.environmentAvatar,
        alt: "Environment logo"
      }) : React.createElement("div", {
        className: classes.defaultEnvironmentLogo
      }, React.createElement("img", {
        className: classes.environmentLogoWrapper,
        src: "/Images/icons/mhc-logo.svg"
      }))), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        color: "inherit",
        component: "span",
        className: classes.environmentText
      }, userInfo.environmentName || ' ')))));
    }
  }]);

  return NavBarEnvironment;
}(React.Component);
/**
 * @typedef {Object} Props
 * @property {Object} [style]
 * @property {Object} [dispatch] Injected by HoC
 * @property {Object} [userInfo] Injected by HoC
 * @property {Object} [classes] Injected by HoC
 * @property {Object} [theme] Injected by HoC
 */


export default connect(function (state) {
  return {
    userInfo: state.userInfo
  };
})(withStyles(styles, {
  withTheme: true,
  name: 'ECNavBarEnvironment'
})(NavBarEnvironment));